<template>
    <v-card>
        <v-card-text class="pb-1">
            <v-row>
                <v-col
                    cols="4">
                    <v-text-field
                        outlined
                        hide-details
                        height="40px"
                        append-icon="search"
                        v-model="pagination.search"
                        :placeholder="$t('placeholder.filterByStaffIDAndName')"/>
                </v-col>

                <v-col cols="2">
                    <v-select
                        outlined
                        hide-details
                        v-model="pagination.role"
                        append-icon="expand_more"
                        height="40px"
                        :items="filterableRoles"/>
                </v-col>
                <v-col>
                    <v-btn
                        class="float-right"
                        color="primary"
                        @click="openCreateStaffPanel">
                        {{ $t('button.createStaff') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-text>
            <staff-table
                :search="pagination.search"
                :items="staffs"
                :options="pagination"
                @edit="openEditStaffPanel"/>
        </v-card-text>

        <right-panel
            ref="createStaffPanel"
            :title="$t('staffList.details.createHeader')">
            <template v-slot:content="{ context }">
                <staff-details-view
                    create-mode
                    :staff="context"/>
            </template>

            <template v-slot:bottom>
                <v-spacer/>
                <v-btn
                    width="120px"
                    color="primary">
                    {{ $t('button.create') }}
                </v-btn>
            </template>
        </right-panel>

        <right-panel
            ref="editStaffPanel"
            :title="$t('staffList.details.editHeader')">
            <template v-slot:content="{ context }">
                <staff-details-view
                    :staff="context"/>
            </template>

            <template v-slot:bottom>
                <v-menu
                    top
                    offset-y
                    nudge-top="12px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            outlined
                            width="120px"
                            color="primary"
                            v-on="on"
                            v-bind="attrs">
                            <icon
                                class="mr-1"
                                value="hero_Trash"
                                size="18px"/>
                            {{ $t('button.delete') }}
                        </v-btn>
                    </template>
                    <v-card elevation="0">
                        <v-card-title class="error--text">
                            <icon
                                value="error_outline"
                                class="mr-2 error--text"/>
                            {{ $t('staffList.dialog.delete.header') }}
                        </v-card-title>
                        <v-card-text v-html="$t('staffList.dialog.delete.content')">
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer/>
                            <v-btn
                                outlined
                                color="grey">
                                {{ $t('staffList.dialog.delete.cancel') }}
                            </v-btn>
                            <v-btn
                                color="error">
                                {{ $t('staffList.dialog.delete.confirm') }}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
                <v-spacer/>
                <v-btn
                    width="120px"
                    color="primary">
                    {{ $t('button.save') }}
                </v-btn>
            </template>
        </right-panel>
    </v-card>
</template>

<script>
import RightPanel from '@/components/panels/RightPanel'
import StaffTable from '@/components/tables/StaffTable'
import StaffDetailsView from '@/views/StaffDetailsView'

export default {
    name: 'StaffListView',

    components: {
        RightPanel,
        StaffTable,
        StaffDetailsView
    },

    props: {
        staffs: {
            type: Array,
            default: () => []
        },

        pagination: {
            type: Object,
            default: () => ({})
        }
    },

    data () {
        return {
            roles: [
                'Staff',
                'Administrator'
            ]
        }
    },

    computed: {
        filterableRoles () {
            return ['All Role', ...this.roles]
        }
    },

    methods: {
        openEditStaffPanel (staffItem) {
            this.$refs.editStaffPanel.open(staffItem)
        },

        openCreateStaffPanel () {
            this.$refs.createStaffPanel.open({})
        }
    }
}
</script>

<style lang="scss" scoped></style>
